import tinycolor from "tinycolor2";
import { createTheme } from "@material-ui/core";

const primary = "#74BACD";
const secondary = "#7F8AAC";
const zennyaSecondary = "#85CBC8";
const warning = "#FFC260";
const success = "#3CD4A0";
const info = "#74BACD";

const lightenRate = 7.5;
const darkenRate = 15;

const theme = createTheme();

export const colorPalette = {
  primary: {
    main: primary,
    light: tinycolor(primary).lighten(lightenRate).toHexString(),
    whisper: tinycolor(primary).lighten(25).toHexString(),
    dark: tinycolor(primary).darken(darkenRate).toHexString(),
  },
  secondary: {
    main: secondary,
    light: tinycolor(secondary).lighten(lightenRate).toHexString(),
    whisper: tinycolor(secondary).lighten(35).toHexString(),
    dark: tinycolor(secondary).darken(darkenRate).toHexString(),
    contrastText: "#FFFFFF",
  },
  warning: {
    main: warning,
    light: tinycolor(warning).lighten(lightenRate).toHexString(),
    whisper: tinycolor(warning).lighten(25).toHexString(),
    dark: tinycolor(warning).darken(darkenRate).toHexString(),
  },
  success: {
    main: success,
    light: tinycolor(success).lighten(lightenRate).toHexString(),
    whisper: tinycolor(success).lighten(25).toHexString(),
    dark: tinycolor(success).darken(darkenRate).toHexString(),
  },
  info: {
    main: info,
    light: tinycolor(info).lighten(lightenRate).toHexString(),
    whisper: tinycolor(info).lighten(25).toHexString(),
    dark: tinycolor(info).darken(darkenRate).toHexString(),
  },
  black: {
    main: '#FFFFFF',
  },
  text: {
    primary: "#4f4f4f",
    secondary: "#6E6E6E",
    hint: "#B9B9B9",
  },
  background: {
    default: '#FFFFFF',
    light: '#F3F5FF',
    card: '#F8F8F8'
  },
  link: {
    main: "#66B5D7",
  },
  default: {
    main: "#C4C4C4",
  },
};

export const BrandonG = [
  'Brandon',
  'sans-serif',
].join(',')
export const HelvNeue = [
  'HelvNeue',
  'sans-serif',
].join(',')

const overrides = {
  breakpoints: {
    values: {
      xs: 0, // phone
      sm: 600, // tablets
      md: 900, // small laptop
      lg: 1200, // desktop
      xl: 1536, // large screens
    },
  },
  typography: {
    fontFamily: HelvNeue,
    h1: {
      fontSize: "3rem",
      fontFamily: BrandonG,
      fontWeight: 500
    },
    h2: {
      fontSize: "2rem",
      fontFamily: BrandonG,
      fontWeight: 500
    },
    h3: {
      fontSize: "1.64rem",
      fontFamily: BrandonG,
      fontWeight: 500
    },
    h4: {
      fontSize: "1.5rem",
      fontFamily: BrandonG,
      fontWeight: 500
    },
    h5: {
      fontSize: "1.285rem",
      fontFamily: BrandonG,
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontFamily: BrandonG,
      fontWeight: 500
    },
    subtitle1: {
      fontFamily: BrandonG,
      fontWeight: 300
    },
    subtitle2: {
      fontFamily: BrandonG,
      fontWeight: 300
    },
    body1: {
      fontFamily: HelvNeue
    },
    body2: {
      fontFamily: HelvNeue
    },
    button: {
      fontFamily: BrandonG,
      fontWeight: 300
    },
    caption: {
      fontFamily: HelvNeue,
      fontWeight: 300
    },
    overline: {
      fontFamily: HelvNeue
    },
  },
  shape: {
    borderRadius: 15,
  },
  overrides: {
    MuiAppBar: {
      colorDefault: {
        backgroundColor: "white",
      }
    },
    MuiTableCell: {
      head: {
        fontWeight: 700,
        fontSize: ".85rem",
      },
    },
    MuiCard: {
      root: {
        marginBottom: "10px",
        borderRadius: 15,
        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0",
      },
    },
    MuiChip:{
        colorPrimary: {
          backgroundColor: colorPalette.primary.main,
        },
        colorSecondary: {
          backgroundColor: colorPalette.secondary.main,
        },
      
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: "15px",
      },
    },
    MuiFormControl: {
      root: {
        borderRadius: "15px",
      },
    },
    MuiAutocomplete: {
      root: {
        borderRadius: "15px",
      },
    },
    MuiButton: {
      root: {
        borderRadius: "50px",
        fontWeight: 400,
        
      },
      contained: {
        backgroundColor: "#fff",
        color: "#4F4F4F",
      },
      containedPrimary: {
        color: "#fff",
      },
      outlined: {
        backgroundColor: "#ffff",
      },
      outlinedPrimary: {
        "&:hover": {
          backgroundColor: "#ffffff",
          "@media (hover: none)": {
            backgroundColor: "#f0f0f0",
          },
        },
      },
      
    },
    MuiCardHeader:{
      title: {
        fontWeight: 700,
        fontFamily: HelvNeue,
      },
      subheader:{
        fontWeight: 500,
        fontFamily: HelvNeue,
        fontSize: "1.142rem",
      },
      action:{
        margin: 'auto'
      }
    },
    MuiPickersDay: {
      root: {
        "&$disabled": {
          textDecoration: 'line-through',
          color: "#B9B9B9",
        },
      },
    },
  },
}

const light = {
  palette: { type: "light", ...colorPalette },
  ...overrides,
}
const dark = {
  palette: {
    type: "dark",
    ...colorPalette,
    text: {
      primary: "#fff",
      secondary: "#fff",
      hint: "#B9B9B9",
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary).lighten(lightenRate).toHexString(),
      dark: tinycolor(secondary).darken(darkenRate).toHexString(),
      contrastText: "#FFFFFF",
      whisper: tinycolor(secondary).lighten(35).toHexString(),
    },
  },
  ...overrides,
}
const ZennyaTheme = {
  light,
  dark,
  createBookingTheme: {
    ...light,
    overrides:{
      ...overrides.overrides,
      MuiContainer:{
        root:{
          marginLeft:'unset'
        }
      },
      MuiCardHeader: {
        title: {
          fontWeight: 700,
          fontFamily: HelvNeue,
          fontSize: "2rem",
          [theme.breakpoints.down("md")]: {
            fontSize: "1.256rem",
          },
        },
        subheader: {
          fontWeight: 500,
          fontFamily: BrandonG,
          fontSize: "1rem",
          paddingTop: 10
        },
        action: {
          margin: 'unset',
          marginTop: 'unset',
          marginRight: 'unset'
        }
      },
    }
  },
  createBookingThemeDark:{
    ...dark,
    overrides: {
      ...overrides.overrides,
      MuiContainer:{
        root:{
          marginLeft:'unset'
        }
      },
      MuiCardHeader: {
        title: {
          fontWeight: 700,
          fontFamily: HelvNeue,
          fontSize: "2rem",
        },
        subheader: {
          fontWeight: 500,
          fontFamily: BrandonG,
          fontSize: "1rem",
          paddingTop: 10
        },
        action: {
          margin: 'unset',
          marginTop: 'unset',
          marginRight: 'unset'
        }
      },
    }

  }
};

export default ZennyaTheme;
